import React from 'react';
import { Col, Row } from 'react-bootstrap';

import camLoeppky from '../../../assets/images/camLoeppky.png';
import ReadMore from '../../components/ReadMore';

const MessageFromChairman = ({ width, isMobile }) => {
  return (
    <Col>
      <Row>
        <Col xs={12} sm={7} md={8} 
        lg={9} xl={9}
        // xl={10}
        >
          <Row>
            <Col xs={isMobile ? 12 : 7} sm={12}>
              <h2
                id="message-from-the-chairman-of-the-board"
                tabIndex="-1"
                style={{ textAlign: 'left' }}
              >
                message from the {width < 576 ? 'CHAIR-\nMAN' : 'CHAIRMAN'}  of the board
              </h2>
            </Col>
            {!isMobile && width < 576 && <Member />}
          </Row>

          <div className="quoteSubheader" style={{ marginTop: 30 }}>
            “It’s impressive to see how quickly we as brokers, vendors and insurer members were able to pivot to the digital space and make great strides despite the circumstances.”
          </div>
          <p style={{ marginTop: 30 }}>
            The COVID-19 pandemic led to a massive increase in remote work. More people were adopting digital processes and solutions, scaling connectivity and securing undisrupted workflows for those who work in the P&C insurance industry and the customers they serve.
          </p>
          <ReadMore href="/message-from-chairman#top" />
        </Col>
        {!isMobile && width >= 576 && <Member />}
      </Row>
    </Col>
  )
}

export default MessageFromChairman;

const Member = () => (
  <Col xs={5} sm={5} md={4} lg={3} xl={3}
  // xl={2} 
  style={{
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    // paddingLeft: 60,
  }}>
    <img
      src={camLoeppky}
      style={{
        width: '100%',
        height: 'auto',
        marginLeft: 40,
        marginRight: 40,
        // marginTop: 60
        marginTop: 8,
        marginBottom: 25
      }}
      aria-label="picture of Cam Loeppky"
    />
    <div className="homepageExecName">
      CAM LOEPPKY
    </div>
    <div className="homepageExecTitle">
      CSIO CHAIRMAN
    </div>
    <div className="homepageExecDetail" style={{ paddingLeft: 8, paddingRight: 8}}>
      The Wawanesa Mutual Insurance Company<br/>Senior Vice President & Chief Information Officer
    </div>
  </Col>
);
